import type EnType from '../en-US/settings';

export default {
  'app.settings.hasNoSetting': 'Não configurado',
} satisfies typeof EnType;
